module.exports = __webpack_public_path__ + "static/media/nima_walking_2ba.a6d0ca07.gif";